import { format } from 'date-fns';
import { DateRange } from 'react-day-picker';

// Helper function for auto-expanding textarea
export const handleTextareaAutoResize = (e: React.FormEvent<HTMLTextAreaElement>, maxHeight: number = 120) => {
  const target = e.target as HTMLTextAreaElement;
  target.style.height = 'auto';
  target.style.height = Math.min(target.scrollHeight, maxHeight) + 'px';
};

export const formatDateRange = (dateRange: DateRange | null | undefined): string => {
  if (!dateRange?.from || !dateRange?.to) {
    return '';
  }
  const fromDate = format(dateRange.from, 'dd/MM/yyyy HH:mm');
  const toDate = format(dateRange.to, 'dd/MM/yyyy HH:mm');
  return `${fromDate} - ${toDate}`;
};
